import React, { useContext } from "react";
import PropTypes from "prop-types";
import styles from "../entity-calendar.module.scss";
import ReactCountryFlag from "react-country-flag";
import { EntityContext } from "..";
import { eventTypes } from "../utils";
import { Card } from "primereact/card";

function EntityCalendarEvent({
  title,
  subTitle,
  label,
  type,
  country,
  oneliner,
  start,
  end,
  id,
  handleSelectEvent,
  color,
  backgroundColor,
  status,
  process,
  due_date_utc,
  processData,
}) {
  const { entity } = useContext(EntityContext);

  const renderStatus = (status) => (
    <p className="status">
      <span
        className="status-dot"
        style={{ background: status.primary_color }}
      />
      {status.name}
    </p>
  );

  const countryFlag =
    type === eventTypes.HOLIDAY ? (
      <ReactCountryFlag
        countryCode={entity.country}
        svg
        className={styles.flag}
      />
    ) : null;

  return (
    <Card
      style={{
        borderInlineStartColor: color,
        backgroundColor: backgroundColor,
      }}
      onClick={() => {
        handleSelectEvent({
          title,
          subTitle,
          label,
          type,
          country,
          start,
          oneliner,
          id,
          status,
          end,
          color,
          process,
          due_date_utc,
          processData,
        });
      }}
    >
      <p className="event-service-name">{label}</p>
      <p
        className={`event-name ${type !== eventTypes.HOLIDAY ? "event-title" : ""}`}
      >
        {title}
      </p>
      {countryFlag || subTitle ? (
        <p className="sub-title">
          {countryFlag}
          {subTitle}
        </p>
      ) : null}
      {status && renderStatus(status)}
    </Card>
  );
}

EntityCalendarEvent.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  status: PropTypes.shape({
    primary_color: PropTypes.string,
    secondary_color: PropTypes.string,
    name: PropTypes.string,
  }),
  country: PropTypes.string,
  oneliner: PropTypes.string,
  start: PropTypes.instanceOf(Date),
  end: PropTypes.instanceOf(Date),
  due_date_utc: PropTypes.instanceOf(Date),
  id: PropTypes.string,
  process: PropTypes.string,
  setIsOpen: PropTypes.func,
  setEventDetail: PropTypes.func,
  handleSelectEvent: PropTypes.func,
  processData: PropTypes.object,
};

export default EntityCalendarEvent;
